import { render, staticRenderFns } from "./LightGalleryThumbnails.vue?vue&type=template&id=cb3c0984"
import script from "./LightGalleryThumbnails.vue?vue&type=script&lang=js"
export * from "./LightGalleryThumbnails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports